import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { Check } from "lucide-react";

export default function Fees() {
  const fees = useContent().fees;
  return (
    <section className="py-20 lg:py-28 bg-[#faf8f4]">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center reveal">
          <div className="eyebrow mb-4">{fees.eyebrow}</div>
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold">{fees.title}</h2>
        </div>

        <div className="mt-12 rounded-2xl bg-white border border-[#efe9dd] overflow-hidden">
          {fees.rows.map((r, i) => (
            <div
              key={r.k}
              className={`flex items-center justify-between px-6 py-5 ${
                i !== fees.rows.length - 1 ? "border-b border-[#f0ece3]" : ""
              }`}
            >
              <span className="text-[#3a4258]">{r.k}</span>
              <span className="font-medium text-[#16233d] text-right">{r.v}</span>
            </div>
          ))}
        </div>

        <div className="mt-6 flex items-center justify-center gap-2 text-sm text-[#8f6f3f]">
          <Check size={17} className="text-[#b08d57]" /> {fees.note}
        </div>
      </div>
    </section>
  );
}
